/**
 * @fileoverview Static defaults used across the Teacher Assessment Drawer.
 */

export const ALL_STUDENTS_VALUE = '__all_students__'

/**
 * Debounce for the silent teacher-notes autosave (AR-753). Mirrors the
 * student drawer's journal debounce in `ArcStudentAssessmentDrawerContent`.
 */
export const NOTES_AUTOSAVE_DEBOUNCE_MS = 700

export const NOTES_TEXTAREA_MIN_ROWS = 3

/**
 * Fallback rubric text shown under each selected score. Used when neither
 * `Lv4Item.score{N}_rubric` (default per curriculum item) nor the custom
 * `ActivityLv4ItemHowToAssess` (not yet exposed by the backend — gap noted
 * in `.tmp/AR-539-backend-gap.md`) is available.
 *
 * Mirrors `DEFAULT_CRITERIA` from `arcmosaico-prototype/components/Projects/
 * CustomCriteriaModal.tsx`.
 */
export const DEFAULT_CRITERIA: Record<1 | 2 | 3 | 4 | 5, string> = {
  1: 'Unable to demonstrate the skill at this time',
  2: 'Skill is emerging with consistent adult support',
  3: 'Skill is developing well with occasional adult support',
  4: 'Skill is developed and independently applied',
  5: 'Skill is fully developed and applied with innovation and creativity',
}
